import { Box, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { toCustomUTCDateString } from '../../../../../components/common/time/timeHelper'
import { RiskLevelSlider } from '../../../../../components/utilities/RiskLevelSlider'
import RiskTypes from '../components/RiskTypes'

const ExecutiveSummary = ({ riskHistory, riskLevel, name }) => {
  const { t } = useTranslation(['common'])
  const risk = riskLevel ? riskLevel : riskHistory?.current?.riskLevel ? riskHistory?.current?.riskLevel : '---'
  const evalDate = riskHistory?.current?.riskResult?.date
    ? toCustomUTCDateString(riskHistory.current.riskResult.date)
    : undefined

  return (
    <>
      <Paper elevation={0} variant="colorPrimary">
        {t('common:executiveSummary')}
      </Paper>

      {/* TIPOS DE RIESGO */}
      <Typography variant="subtitle1">{t('common:riskLevelDesc')}</Typography>
      <RiskTypes />

      <Box>
        <Typography variant="subtitle4">
          {t('common:results')} {t('common:for')}: {name ?? ''}
        </Typography>
        <Paper
          variant="rootOutlined"
          elevation={0}
          sx={{ display: 'flex', flexDirection: 'column', gap: '.5rem', p: 2 }}
        >
          <div className="c-detail-row">
            <RiskLevelSlider type={risk} showDetail={false} />
          </div>
          {evalDate && (
            <div className="c-detail-row">
              <Typography variant="subtitle1">{t('common:evaluationDate')}:</Typography>
              <Typography variant="subtitle3">{evalDate}</Typography>
            </div>
          )}
        </Paper>
      </Box>
    </>
  )
}

export default ExecutiveSummary
